import { z } from 'zod'

export const UserSchema = z.object({
  id: z.number().int().positive(),
  email: z.string().email(),
  displayName: z.string(),
  locale: z.string().optional(),
})

export type User = z.infer<typeof UserSchema>
